import { createAsyncAction } from 'typesafe-actions';

import { getDictionary } from '@travel/i18n';
import { getTranslation } from '@travel/translation';
import { isNotEmptyValue } from '@travel/utils';

import { updateSEOData } from 'store/seo/actions';

import paths from 'constants/paths';
import { DESCRIPTION, PAGE_INDICATOR, TITLE } from 'domestic/src/constants/seo';
import { getIPAddress } from 'store/utils';
import { normalizePathIdentifier } from 'utils/search';
import { fetchProviderDetails as fetchProviderDetailsAPI } from './apis';
import { getProviderDetails } from './selectors';
import { getSearchEngine } from 'store/searchEngine/selectors';

import type { AppThunk } from 'typesafe-actions';
import type { ProviderDetails, ProviderDetailsErrors } from 'ProviderDetails-Types';
export const fetchProviderDetailsAsync = createAsyncAction(
  'FETCH_PROVIDER_DETAILS_REQUEST',
  'FETCH_PROVIDER_DETAILS_SUCCESS',
  'FETCH_PROVIDER_DETAILS_FAILURE',
)<undefined, ProviderDetails, ProviderDetailsErrors>();

export const fetchProviderDetails =
  (id: string): AppThunk =>
  async (dispatch, getState, { apiClient, req }) => {
    try {
      const { providerDetails } = getState();
      const searchEngine = getSearchEngine(getState());

      if (id !== providerDetails.providerDetails?.id) {
        dispatch(fetchProviderDetailsAsync.request());
      }
      const response = await fetchProviderDetailsAPI(
        apiClient,
        id,
        getIPAddress(req),
        searchEngine,
      );
      dispatch(fetchProviderDetailsAsync.success(response));
    } catch (error) {
      dispatch(fetchProviderDetailsAsync.failure(error as ProviderDetailsErrors));
      throw error;
    }
  };

export const fetchSEOData =
  (imageUrl: string, isIndexablePage: boolean = false, pageNumber: number = 1): AppThunk =>
  async (dispatch, getState) => {
    const state = getState();
    const dictionary = getDictionary(state);
    const providerDetails = getProviderDetails(state);

    const isDynamicUrl = isNotEmptyValue(state.router.location.location.search);
    const titleId = isDynamicUrl
      ? 'Domestic.JRDP.Plan_List.Generic.Title'
      : `Domestic.JRDP.Plan_List.${TITLE}`;

    const descriptionId = isDynamicUrl
      ? 'Domestic.JRDP.Plan_List.Generic.Description'
      : `Domestic.JRDP.Plan_List.${DESCRIPTION}`;

    let pathUrl = paths.plansList.pathResolver(`${providerDetails.id}`);

    if (pageNumber !== 1) {
      const { normalizePath } = normalizePathIdentifier(pathUrl);
      pathUrl = `${normalizePath}${PAGE_INDICATOR}${pageNumber}/`;
    }

    dispatch(
      updateSEOData({
        title: providerDetails.pathId
          ? getTranslation(
              {
                id: titleId,
                data: { hotelname: providerDetails.name },
              },
              dictionary,
            )?.join('')
          : getTranslation(
              { id: 'DP_Common.Error_Message.Application_Error.Fatal.HTML_Title' },
              dictionary,
            )?.join(''),
        description: getTranslation(
          {
            id: descriptionId,
            data: { hotelname: providerDetails.name },
          },
          dictionary,
        )?.join(''),
        isIndexablePage: isIndexablePage,
        canonicalPath: pathUrl,
        imageUrl,
        isDynamicUrl,
      }),
    );
  };
